import Vue from "vue";
import Element from "element-ui";
import "../assets/theme/index.css";

Vue.use(Element);
